module.exports = new __parcel__URL__("shop_machines_kaiju_kingmaker.3d0ee275.png").toString();